var map = {
	"./BidCreate.gql": "75f9",
	"./LeadCreate.gql": "285c",
	"./PurchaseCreate.gql": "291f",
	"./ShopContractPrepareSigning.gql": "28498",
	"./TaskCreate.gql": "fe2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67e2";